import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export function getEngagementslist(filters = {}) {
  return axiosRequest('post', serviceUrls.ENGAGEMENTS_GET_ALL, filters, null, null, filters);
}

// export function getEngagementsDetails(filters = {}) {
//   return axiosRequest('get', serviceUrls.ENGAGEMENTS_GET_DETAILS, filters);
// }

export function saveEngagements(payload) {
  return axiosRequest('post', serviceUrls.ENGAGEMENTS_SAVE_DETAILS, payload);
}

export function getEngagementsDetails(engagementApplicationEnvironmentKey) {
  return axiosRequest('get', serviceUrls.ENGAGEMENTS_GET_DETAILS + engagementApplicationEnvironmentKey, null, null, {
    engagementApplicationEnvironmentKey,
  });
}

export function getEngagementUsers(filters = {}) {
  return axiosRequest('post', serviceUrls.USERS_GET_ALL, filters, null, null, { engagementKey: filters.engagementKey });
}

export function saveEngagementusers(payload) {
  return axiosRequest('post', serviceUrls.ENGAGEMENTS_SAVE_USERS, payload);
}
export function getEngagementTeamslist(payload) {
  return axiosRequest('post', serviceUrls.ENGAGEMENT_TEAMS_LIST_DETAILS, payload, null, null, {
    engagementApplicationEnvironmentKey: payload.engagementApplicationEnvironmentKey,
  });
}

export function getExperianValidatedList(payload) {
  return axiosRequest('get', serviceUrls.EXPERIAN_VALIDATED_LIST, payload,null,null,{
    isFromFilter:payload
  });
}

export function getCountrylistDetails() {
  return axiosRequest('get', serviceUrls.ENGAGEMENT_USER_COUNTRY_LIST);
}

export function getEngagementUserslist(payload) {
  return axiosRequest('post', serviceUrls.ENGAGEMENTS_TEAM_USERS_DETAILS, payload, null, null, {
    engagementApplicationEnvironmentKey: payload.engagementApplicationEnvironmentKey,
  });
}

export function saveEngagementteamDetails(payload) {
  return axiosRequest('post', serviceUrls.ENGAGEMENT_TEAM_SAVE_DETAILS, payload, null, null, {
    engagementApplicationEnvironmentKey: payload.engagementApplicationEnvironmentKey,
  });
}
export function getEngagementteamDetails(payload) {
  return axiosRequest('get', serviceUrls.ENGAGEMENT_TEAM_GET_DETAILS, payload);
}

export function searchEngagementTeamMemberService(payload) {
  return axiosRequest('post', serviceUrls.ENGAGEMENT_SEARCH_TEAM_MEMBER, payload, null, null, {
    engagementTeamId: payload.engagementTeamId,
  });
}

export function searchEngagementTeamCountryService(payload) {
  return axiosRequest('get', serviceUrls.ENGAGEMENT_SEARCH_TEAM_COUNTRY, payload);
}
export function getEngagementDataAccessGroups(payload) {
  return axiosRequest('get', serviceUrls.ENGAGEMENT_DATA_ACCESS_GROUP_DETAILS, payload, null, null, {
    engagementApplicationEnvironmentKey: payload.engagementApplicationEnvironmentKey,
  });
}

export function fetchChaseFrequencyList() {
  return axiosRequest('post', serviceUrls.FETCH_CASE_FREQUENCY_LIST);
}

export function fetchSlaTriggerQuestionnaireList() {
  return axiosRequest('get', serviceUrls.FETCH_SLA_QUESTIONNAIRE_LIST);
}

export function getDelegateClientViewList() {
  return axiosRequest('get', serviceUrls.GET_DELEGATE_CLIENT_VIEW_LIST);
}


// WEBPACK FOOTER //
// ./src/services/engagements.service.js